import React from 'react';
import { RulerIcon } from 'lucide-react';
import { ServicePage } from '../components/ServicePage';
import { services } from '../data/site';
const service = services.find(s => s.key === 'plomberie')!;
export function Plomberie() {
  return <ServicePage service={service} note="L'aménagement peut être réalisé clés en main, y compris pour les salles de bains adaptées aux personnes à mobilité réduite." data-id="element-303" data-mp="3gfu9ir29569a">
      <div className="mt-8 rounded-2xl border border-line bg-surface p-6 sm:p-7" data-id="element-304" data-mp="3q66s4dqiapcs">
        <RulerIcon className="h-7 w-7 text-ember-500" aria-hidden="true" data-id="element-305" data-mp="3u7ikgr0rlooo" />
        <h2 className="mt-4 font-display text-lg font-extrabold text-navy-800" data-id="element-306" data-mp="32ijajm2xbj6">
          Exemple de réalisation
        </h2>
        <p className="mt-2 text-[1rem] leading-relaxed text-navy-600" data-id="element-307" data-mp="80am48o9ii25">
          Réalisation d'une salle d'eau dans un espace réduit de 3 m x 3 m.
        </p>
      </div>
    </ServicePage>;
}